<template>
<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-color-image`]" width="1em" height="1em" v-bind="$attrs"><path d="M4.07251 16.3809L7.91563 13.71L9.83719 15.0455L11.7588 16.3809M19.9254 17.2312L13.3088 12.6328L11.573 13.8391" stroke="#00BBD8" stroke-width="1.66" stroke-linecap="round" stroke-linejoin="round"/><path d="M10.0063 20.1888H13.9917C16.2319 20.1888 17.352 20.1888 18.2076 19.7528C18.9603 19.3693 19.5722 18.7574 19.9557 18.0048C20.3917 17.1491 20.3917 16.029 20.3917 13.7888V9.7083C20.3917 8.43192 20.3917 7.79373 20.2473 7.27108C19.8727 5.91468 18.8129 4.85489 17.4565 4.48028C16.9339 4.33594 16.2957 4.33594 15.0193 4.33594H13.0899H10.0063C7.76605 4.33594 6.64595 4.33594 5.7903 4.77191C5.03765 5.1554 4.42573 5.76733 4.04224 6.51998C3.60626 7.37562 3.60626 8.49573 3.60626 10.7359V13.7888C3.60626 16.029 3.60626 17.1491 4.04224 18.0048C4.42573 18.7574 5.03765 19.3693 5.7903 19.7528C6.64595 20.1888 7.76605 20.1888 10.0063 20.1888Z" stroke="#165DFF" stroke-width="1.66" stroke-linecap="round" stroke-linejoin="round"/></svg>
</template>
<script>

export default {
  name: 'IconColorImage',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
